import React, { FormEvent } from 'react'

import { Switch } from '@audio-network/componentlibrary'
import styles from './VocalFilter.module.css'
import { useToggleRefinement } from 'react-instantsearch'
import { useTranslation } from 'next-i18next'

const VocalFilter = (): JSX.Element => {
	const { t } = useTranslation(['search'])

	const { value, refine } = useToggleRefinement({ attribute: 'Vocal' })
	const { refine: instrumentalRefine } = useToggleRefinement({
		attribute: 'Instrumental',
	})

	const toggleVocals = (event: FormEvent): void => {
		refine({ isRefined: !(event.target as HTMLInputElement).checked })
		if ((event.target as HTMLInputElement).checked === true) {
			instrumentalRefine({
				isRefined: true,
			})
		}
	}
	return (
		<Switch
			checked={value.isRefined}
			className={styles.switch}
			data-testid="vocal-switch"
			label={t('vocals-toggle')}
			onChange={toggleVocals}
		/>
	)
}

export default VocalFilter
